var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "TerminalMessage" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Code",
                        error: _vm.$v.form.Code,
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.terminalMessage.definitions"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "MessageSubject",
                            error: _vm.$v.form.MessageSubject,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.MessageSubject
                            },
                            model: {
                              value: _vm.form.MessageSubject,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "MessageSubject", $$v)
                              },
                              expression: "form.MessageSubject"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "MessageBody",
                            error: _vm.$v.form.MessageBody,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.MessageBody
                            },
                            model: {
                              value: _vm.form.MessageBody,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "MessageBody", $$v)
                              },
                              expression: "form.MessageBody"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "MessageTypeId",
                            error: _vm.$v.form.MessageTypeId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "MESSAGE_TYPE",
                              disabled: _vm.insertReadonly.MessageTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("MessageTypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.selectedMessageType,
                              callback: function($$v) {
                                _vm.selectedMessageType = $$v
                              },
                              expression: "selectedMessageType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_CRITERIA",
                              disabled:
                                !_vm.selectedMessageType ||
                                _vm.selectedMessageType.Code !== "MM"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedCustomerCriteria,
                              callback: function($$v) {
                                _vm.selectedCustomerCriteria = $$v
                              },
                              expression: "selectedCustomerCriteria"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.terminalMessage.validDates") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { type: "get", items: _vm.validDateItems },
                    model: {
                      value: _vm.form.TerminalMessageValidDates,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "TerminalMessageValidDates", $$v)
                      },
                      expression: "form.TerminalMessageValidDates"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.terminalMessage.branchs") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "NextDetailPanel",
                    {
                      attrs: { items: _vm.messageBranchItems },
                      model: {
                        value: _vm.form.TerminalMessageBranchs,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "TerminalMessageBranchs", $$v)
                        },
                        expression: "form.TerminalMessageBranchs"
                      }
                    },
                    [
                      _c("template", { slot: "grid" }, [
                        _c(
                          "div",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c("NextMultipleSelection", {
                              attrs: {
                                name: "TerminalMessageMultipleBranch",
                                "hidden-values": _vm.hiddenValuesBranch
                              },
                              model: {
                                value: _vm.form.TerminalMessageBranchs,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "TerminalMessageBranchs",
                                    $$v
                                  )
                                },
                                expression: "form.TerminalMessageBranchs"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedCustomerCriteria &&
              _vm.selectedCustomerCriteria.Code === "MK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.terminalMessage.customerCriterias"
                        )
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          type: "get",
                          items: _vm.customerCriteriaItems
                        },
                        model: {
                          value: _vm.customerCriterias,
                          callback: function($$v) {
                            _vm.customerCriterias = $$v
                          },
                          expression: "customerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedCustomerCriteria &&
              _vm.selectedCustomerCriteria.Code === "ML"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t("insert.terminalMessage.customerList")
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c(
                        "NextDetailPanel",
                        {
                          attrs: { type: "get", items: _vm.customerListItems },
                          model: {
                            value: _vm.customerList,
                            callback: function($$v) {
                              _vm.customerList = $$v
                            },
                            expression: "customerList"
                          }
                        },
                        [
                          _c("template", { slot: "grid" }, [
                            _c(
                              "div",
                              { attrs: { cols: "12", md: "2" } },
                              [
                                _c("NextMultipleSelection", {
                                  attrs: {
                                    name: "TerminalMessageMultipleCustomer",
                                    "hidden-values": _vm.hiddenValues
                                  },
                                  model: {
                                    value: _vm.customerList,
                                    callback: function($$v) {
                                      _vm.customerList = $$v
                                    },
                                    expression: "customerList"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedCustomerCriteria &&
              _vm.selectedCustomerCriteria.Code === "MS"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t("insert.terminalMessage.customerQuery")
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { type: "get", items: _vm.custSqlItems },
                        model: {
                          value: _vm.form.TerminalMessageCustSqls,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "TerminalMessageCustSqls", $$v)
                          },
                          expression: "form.TerminalMessageCustSqls"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedMessageType && _vm.selectedMessageType.Code === "RM"
                ? _c(
                    "b-tab",
                    {
                      attrs: { title: _vm.$t("insert.terminalMessage.routes") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { type: "get", items: _vm.routeItems },
                        model: {
                          value: _vm.form.TerminalMessageRoutes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "TerminalMessageRoutes", $$v)
                          },
                          expression: "form.TerminalMessageRoutes"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cb93e91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb93e91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TerminalMessage/update.vue
// module id = null
// module chunks = 